"use strict";
export const MAX_SCALE = 200;
export const ZOOM_STEP = 5;
